module.exports = __webpack_public_path__ + "img/checklists.92107d39.svg";